<template>
  <div class="wrapper">
    <div class="caption">Leistungsausschluss</div>
    <div class="exclusion" v-if="healthElements.length">
      Behandlungen, die im Zusammenhang mit den angegebenen Vorerkrankungen stehen, oder sich zukünftig aus diesen Vorerkrankungen ergeben, sind vom Leistungsumfang ausgeschlossen:
      <div class="options">
        <ul>
          <li v-for="healthElement in healthElements" :key="healthElement.id">
            <img src="@/assets/images/x.svg"/>
            <span>{{ healthElement.description || healthElement.preCondition.name }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="exclusion" v-if="symptomElements.length" :class="{mt: healthElements.length}">
      Behandlungen, die aus den hier angegebenen Symptomen resultieren, sind vom Leistungsumfang ausgeschlossen:
      <div class="options">
        <ul>
          <li v-for="symptomElement in symptomElements" :key="symptomElement.id">
            <img src="@/assets/images/x.svg"/>
            <span>{{ symptomElement.name }}</span>
          </li>
        </ul>
      </div>
    </div>
    <info-block>Bitte beachten Sie, dass die Einreichung von Belegen bei vorerkrankten Tieren nur über folgende Kanäle möglich ist: Online, über das Kundenportal oder per AGILA-App. Eine Einreichung per E-Mail ist in diesem Fall nicht möglich.</info-block>
    <a-btn-set>
      <a-btn primary white @click="cancel">Zurück</a-btn>
      <a-btn @click="done">Weiter</a-btn>
    </a-btn-set>
  </div>
</template>

<script>
import InfoBlock from "@/components/InfoBlock.vue";

export default {
  components: {
    InfoBlock
  },
  props: {
    healthElements: {
      type: Array,
      default: () => []
    },
    symptomElements: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
  }),
  methods: {
    done () {
      this.$emit('done', true)
    },
    cancel () {
      this.$emit('done', false)
    }
  },
  mounted () {

  }
}

</script>

<style lang="scss" scoped>

.wrapper {
  max-width: 400px;

  .caption {
    margin-bottom: 20px;
    font-weight: bold;
    color: #014e9e;
  }

  .options {
    margin-top: 15px;
    li {
      line-height: 30px;
      display: flex;

      img {
        margin-right: 10px;
        width: 12px;
      }
    }
  }

  .button-set .button {
    min-width: unset !important;
    margin: 20px 10px 0 10px;
  }

  .agila-info-block {
    margin: 25px 0 5px;
    color: #6b6b6b;
  }

  .exclusion.mt {
    margin-top: 40px;
  }
}

</style>
